import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setFootprintingDairyFeedAdditive } from "services";

import { FOOTPRINTING_CROP, FOOTPRINTING_DAIRY_FEED_ADDITIVE } from "consts";

import { FootprintingDairyFeedAdditivePayload } from "models";

export const useMutateFootprintingDairyFeedAdditive = (farmId: string, year: number, payload: FootprintingDairyFeedAdditivePayload, primaryDataId?: string) => {
  const queryClient = useQueryClient();
  return useMutation(
    {
      mutationKey: [FOOTPRINTING_DAIRY_FEED_ADDITIVE],
      mutationFn: () => setFootprintingDairyFeedAdditive(payload, primaryDataId),
      onSuccess: async () => {
        const QKs = [
          [FOOTPRINTING_DAIRY_FEED_ADDITIVE, primaryDataId],
          [FOOTPRINTING_CROP, farmId, year],
        ];
        await Promise.all(QKs.map((QK) => queryClient.invalidateQueries({ queryKey: QK })));
        await Promise.all(QKs.map((QK) => queryClient.refetchQueries({ queryKey: QK })));
      },
    },
    queryClient
  );
};
